/*
 * Featured product: shorten the description to a character limit while
 * keeping its formatting (bold, lists, paragraphs). Everything after the
 * cut point is removed, and the "View full product details" link is shown.
 * Without JS the full description renders and the link stays hidden.
 */
(function () {
  function truncate(wrapper) {
    if (wrapper.dataset.truncated) return;
    var limit = parseInt(wrapper.dataset.truncateLimit, 10);
    var content = wrapper.querySelector('.product-description__content');
    var link = wrapper.querySelector('.featured-product__details-link');
    if (!limit || !content) return;

    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    var count = 0;
    var lastKept = null;
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text.trim()) continue;
      if (count + text.length <= limit) {
        count += text.length;
        lastKept = node;
        continue;
      }

      // Cut inside this text node at the last word break before the limit.
      // If no whole word fits, cut before this node and end on the previous one.
      var lastSpace = text.lastIndexOf(' ', limit - count);
      var cut = lastSpace > 0 ? lastSpace : 0;

      var range = document.createRange();
      if (cut > 0) {
        range.setStart(node, cut);
        lastKept = node;
      } else {
        range.setStartBefore(node);
      }
      range.setEnd(content, content.childNodes.length);
      range.deleteContents();

      if (lastKept) {
        lastKept.nodeValue = lastKept.nodeValue.replace(/[\s.,;:!?-]+$/, '') + '\u2026';
      }

      // Drop any elements left empty by the cut (e.g. trailing <p> or <li>)
      content.querySelectorAll('p, li, ul, ol, div, span, strong, em').forEach(function (el) {
        if (!el.textContent.trim() && !el.querySelector('img, iframe, video')) el.remove();
      });

      if (link) link.hidden = false;
      break;
    }

    wrapper.dataset.truncated = 'true';
  }

  function init(root) {
    (root || document).querySelectorAll('[data-truncate-limit]').forEach(truncate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
